import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sessionService } from '../../../application/SessionService';
import { useShowSnackbarMessage } from '../../../hooks/useShowSnackbarMessage';

interface UseSessionLoginCodeProps {
  otpCode: string;
}

type UseSessionLoginCodeResponseProps = ServiceResponse<({ otpCode }: UseSessionLoginCodeProps) => void, void>;

// Hooks act as 'Adapter' layer.
export const useSessionLoginVerifyOtp = (): UseSessionLoginCodeResponseProps => {
  const { showSnackbarMessage } = useShowSnackbarMessage();
  const queryClient = useQueryClient();

  const { isLoading, isSuccess, isError, mutate } = useMutation(
    ({ otpCode }: UseSessionLoginCodeProps) => sessionService.verifyLogin({ otpCode: otpCode.replace(/ /g, ``) }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`user_is_logged`]);
      },
      onError: (err: any) => {
        console.info(`Session Login Verify OTP Error: `, err?.response);
        showSnackbarMessage({
          messageIntlId: `infoerror.drivers.login_otp.error`,
        });
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: mutate,
  };
};
